import { render, staticRenderFns } from "./public-stockproduct.vue?vue&type=template&id=f863bbb4"
import script from "./public-stockproduct.vue?vue&type=script&lang=ts"
export * from "./public-stockproduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports